module.exports = __webpack_public_path__ + "img/book.848af220.png";